
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/track-my-parcel",
      function () {
        return require("private-next-pages/track-my-parcel.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/track-my-parcel"])
      });
    }
  